import React from 'react';

function PowerStripSocket() {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30ZM30 59.09c16.066 0 29.09-13.024 29.09-29.09C59.09 13.934 46.067.91 30 .91 13.934.91.91 13.933.91 30 .91 46.066 13.933 59.09 30 59.09Z"
        fill="#82D1AD"
      />
      <path
        d="M14.357 49.804a25.197 25.197 0 0 0 33.972-2.316 25.317 25.317 0 0 0 6.977-16.914A25.32 25.32 0 0 0 49.07 13.37l-4.323 4.333-3.118-3.124 4.157-4.27A25.198 25.198 0 0 0 11.682 12.5a25.316 25.316 0 0 0-6.99 16.994 25.32 25.32 0 0 0 6.339 17.247l4.323-4.332 3.118 3.124-4.115 4.27Zm3.783-27.809a3.984 3.984 0 0 1 2.45-3.675 3.962 3.962 0 0 1 4.327.862 3.98 3.98 0 0 1 .86 4.336 3.964 3.964 0 0 1-6.475 1.29 3.983 3.983 0 0 1-1.162-2.813Zm16.067 16.123a3.985 3.985 0 0 1 2.437-3.69 3.962 3.962 0 0 1 4.333.849 3.981 3.981 0 0 1-2.8 6.8 3.965 3.965 0 0 1-2.8-1.159 3.983 3.983 0 0 1-1.17-2.8Z"
        fill="#82D1AD"
      />
    </svg>
  );
}

export default PowerStripSocket;
